import { normalizeLocale, type AppLocale, type ThemePreference } from "../preferences/types";

const storageKey = "lyncia.display-preferences";
export function readDisplayPreferences(): { locale: AppLocale; theme: ThemePreference } {
  try {
    const saved = JSON.parse(localStorage.getItem(storageKey) || "null");
    return {
      locale: normalizeLocale(saved?.locale),
      theme: saved?.theme === "dark" || saved?.theme === "light" ? saved.theme :
        (window.matchMedia?.("(prefers-color-scheme: dark)").matches ? "dark" : "light"),
    };
  } catch {
    return { locale: "zh-CN", theme: "light" };
  }
}
export function storeDisplayPreferences(locale: AppLocale, theme: ThemePreference) {
  try { localStorage.setItem(storageKey, JSON.stringify({ locale, theme })); } catch { /* Private browsing may reject storage. */ }
}
export function applyDisplayPreferences(locale: AppLocale, theme: ThemePreference) {
  document.documentElement.dataset.theme = theme;
  document.documentElement.style.colorScheme = theme;
  document.documentElement.lang = locale;
}

const initial = readDisplayPreferences();
applyDisplayPreferences(initial.locale, initial.theme);
